import PopupExternalLinks from './PopupExternalLinks';

export default PopupExternalLinks;
